export default __webpack_public_path__ + "fa84d36e18549f99dcb9bedbb0786066.svg";